package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "zh")
val ZhStrings = Strings(
    analyzer = "分析器",
    appreciationOverview = "增值概览",
    chartLegendInterest = "利息",
    chartLegendPrincipal = "本金",
    chartXaxisMonths = "月数",
    chartYaxisPayment = "付款",
    code = "zh",
    costOfCredit = "信贷成本",
    creditDealAnalyzerDescription = "输入您的贷款详情以获得全面的信贷交易分析。我们的分析器评估关键指标，帮助您了解贷款的真实成本并做出明智的决定。",
    detailsGoodRateLongTerm = "利率不错，但期限较长导致总成本较高。",
    detailsHighApr = "高年化利率 (APR)。",
    detailsHighInterestCost = "总利息成本高。",
    detailsHighRateShortTerm = "利率较高，但期限较短使总成本保持较低。",
    detailsLowApr = "低年化利率 (APR)。",
    detailsLowInterestCost = "总利息成本低。",
    discountsTradeIn = "折扣 / 以旧换新",
    displayName = "中文 (简体)",
    distribution = "分配",
    downPayment = "首付",
    effectiveApr = "年化利率 (APR)",
    headerBalance = "余额",
    headerDate = "日期",
    headerInterest = "利息",
    headerMonth = "#",
    headerPayment = "付款",
    headerPrincipal = "本金",
    hideDetails = "隐藏详情",
    interest = "利息",
    invalidData = "无效数据",
    loanAmountSupportingText = "贷款总额，包括任何额外费用。",
    loanDetails = "贷款详情",
    paymentSupportingText = "您的预计月供。",
    paymentComposition = "付款构成",
    percentSymbol = "%",
    principal = "本金",
    ratingBad = "糟糕的交易",
    ratingExcellent = "极好的交易",
    ratingFair = "一般的交易",
    ratingGood = "不错的交易",
    ratingPoor = "较差的交易",
    schedule = "还款计划",
    showDetails = "显示详情",
    summaryBad = "非常不利，如果可能请避免。",
    summaryExcellent = "极好的财务条件。",
    summaryFair = "条件一般，考虑重新协商。",
    summaryGood = "条件不错，市场标准水平。",
    summaryPoor = "条件较差，成本或利率较高。",
    totalPaid = "支付总额",
    lockTaxRate = "锁定税率",
    unlockTaxRate = "解锁税率",
    currencySymbol = "¥",
    currency = "货币",
    totalCreditAmount = "信贷总额",
    taxAmount = "税费/扣除额",
    netAmountDisbursed = "净发放金额",
    years = "年",
    loanTermTotalMonths = "贷款期限 (月)",
    monthlyInstallment = "月供",
    principalInstallment = "本金分期",
    otherFees = "其他费用",
    insuranceCost = "保险费",
    aprc = "年度费用百分比 (APRC)",
    totalAmountPayable = "应付总额",
    prepaidFeeFixed = "手续费 (固定金额)",
    prepaidFeePercentage = "手续费 (百分比)",
    months = "月",
    description = "此分析器帮助您评估贷款报价是否对您有利。与标准计算器不同，它不需要输入利率。相反，它根据付款和费用计算 APR 和信贷总成本，提供交易评级和详细图表。",
    agree = "同意",
    information = "信息",
    errorCalculationOverflow = "年利率过高，计算溢出。",
    errorTotalPaymentIsLessThanLoanAmount = "收到的金额少于贷款金额。",
    errorDivisionByZero = "除以零",
    errorNegativeResult = "负结果",
    errorRateTooHigh = "费率太高",
    errorCalculation = "请输入正确的数据",
    close = "关闭",

    hi = "你好",
    guest = "访客",
    account = "账户",
    signInWithGoogle = "使用 Google 登录",
    signOut = "退出登录",
    settings = "设置",
    about = "关于",
    privacyPolicy = "隐私政策",
    termsOfService = "服务条款",
    language = "语言",

    theme = "主题",
    light = "浅色",
    dark = "深色",
    system = "系统",
    toggleExpand = "展开/折叠",
)
